import { theme } from '@branchjs/neo-components';
import { css } from 'emotion';

const container = css`
  background-color: ${theme.colors.primary.contrastWhite};
  padding: 80px 0;
  border-radius: 8px;

  &.noBackground {
    background-color: inherit;
  }
`;

const contentContainer = css`
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const title = css`
  margin-top: 24px;
`;

const description = css`
  color: #757c83;
  margin-top: 8px;
`;

export const NoResultsStyles = { container, contentContainer, title, description };
